(function () {
  if (window.__ffNativeSearchLoaded) return;
  window.__ffNativeSearchLoaded = true;

  var MIN_QUERY_LENGTH = 2;
  var COMPACT_PANEL_WIDTH = 999;
  var SEARCH_SELECTOR = '[data-ff-native-search]';
  var INPUT_SELECTOR = '[data-ff-native-search-input]';
  var PANEL_CLASS = 'ff-native-search-panel';
  var MOBILE_OVERLAY_ID = 'ff-native-mobile-search-overlay';
  var THIRD_PARTY_AUTOCOMPLETE_SELECTORS = [
    '.snize-ac-results',
    '.snize-ac-results-content',
    '.snize-ac-overhidden',
    '#snize_ac_results',
    '.snize-instant-widget',
    '.snize-instant-widget-container',
    '.snize-instant-search',
    '#snize-instant-search-results',
    '#snize_results',
    '.searchanise-autocomplete',
    '.cloud-search-autocomplete',
    '#cloud_search_autocomplete',
    '.smart-search-results',
    '.ssw-search-results'
  ].join(',');

  var initializedForms = new WeakSet();
  var formTimers = new WeakMap();
  var activeController = null;
  var cache = new Map();
  var productDetailsCache = new Map();
  var productReviewBadgeCache = new Map();
  var searchReviewDataCache = new Map();
  var globalsBound = false;
  var thirdPartyObserver = null;
  var mobileSearchOverlay = null;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function normalizeUrl(url) {
    if (!url) return '#';
    if (url.indexOf('//') === 0) return url;
    if (url.charAt(0) === '/') return url;
    return '/' + url;
  }

  function normalizeImage(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || image.original_src || '';
  }

  function formatPrice(price) {
    if (price === null || price === undefined || price === '') return '';

    if (typeof price === 'number') {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(price / 100);
    }

    var priceString = String(price).trim();

    if (/[£$€]|[A-Z]{3}/.test(priceString)) {
      return priceString;
    }

    if (/^\d+(\.\d{1,2})?$/.test(priceString.replace(/,/g, ''))) {
      return '£' + priceString;
    }

    return priceString;
  }

  function buildSuggestUrl(query) {
    var url = new URL('/search/suggest.json', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product,collection,article,page');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor');
    return url.toString();
  }

  function setExpanded(form, expanded) {
    var results = form.querySelector('.search-bar__results');
    var menu = form.querySelector('.search-bar__menu-wrapper');
    var panel = form.querySelector('.' + PANEL_CLASS);

    form.classList.toggle('is-expanded', expanded);
    form.classList.toggle('ff-native-search--open', expanded);

    if (results) {
      results.setAttribute('aria-hidden', 'true');
    }

    if (menu) {
      menu.setAttribute('aria-hidden', 'true');
    }

    if (panel) {
      if (expanded) {
        positionPanel(form, panel);
      }

      panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
    }
  }

  function isCompactViewport() {
    return (document.documentElement.clientWidth || window.innerWidth) <= COMPACT_PANEL_WIDTH;
  }

  function positionPanel(form, panel) {
    if (!form || !panel) return;

    var rect = form.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var isCompact = viewportWidth <= COMPACT_PANEL_WIDTH;
    var header = form.closest('.header');
    var wrapper = form.closest('.header__search-bar-wrapper');
    var headerRect = header ? header.getBoundingClientRect() : null;
    var wrapperRect = wrapper ? wrapper.getBoundingClientRect() : null;
    var sourceRect = rect.width > 80 ? rect : wrapperRect || rect;
    var horizontalInset = isCompact ? (viewportWidth <= 640 ? 10 : 16) : 24;
    var width = Math.min(isCompact ? viewportWidth - (horizontalInset * 2) : Math.max(sourceRect.width, 980), viewportWidth - (horizontalInset * 2));
    var left = isCompact ? horizontalInset : sourceRect.left + (sourceRect.width / 2) - (width / 2);
    var top = rect.bottom + 8;

    if (isCompact && headerRect) {
      top = Math.max(rect.bottom, headerRect.bottom) + 8;
    }

    left = Math.min(Math.max(horizontalInset, left), viewportWidth - width - horizontalInset);

    panel.style.setProperty('--ff-native-search-top', Math.round(top) + 'px');
    panel.style.setProperty('--ff-native-search-left', Math.round(left) + 'px');
    panel.style.setProperty('--ff-native-search-width', Math.round(width) + 'px');
    panel.style.setProperty('--ff-native-search-max-height', Math.max(isCompact ? 280 : 220, Math.round(viewportHeight - top - (isCompact ? 10 : 18))) + 'px');
  }

  function setLoading(form, isLoading) {
    form.classList.toggle('is-loading', isLoading);
  }

  function viewAllMarkup(query) {
    var url = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
    return [
      '<a class="search-bar__view-all ff-native-search__view-all" href="' + url + '">',
      'View all products',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 18 15 12 9 6"></path></svg>',
      '</a>'
    ].join('');
  }

  function ratingMarkup(product) {
    var productId = product && product.id ? String(product.id).trim() : '';

    if (product && product.reviewBadgeHtml) {
      return [
        '<span class="ff-native-search__rating">',
        '<span class="jdgm-widget jdgm-preview-badge" data-id="' + escapeHtml(productId) + '" data-template="manual-installation" data-auto-install="false">',
        product.reviewBadgeHtml,
        '</span>',
        '</span>'
      ].join('');
    }

    if (!productId) {
      return '<span class="ff-native-search__rating ff-native-search__rating--empty" aria-hidden="true"></span>';
    }

    return [
      '<span class="ff-native-search__rating">',
      '<span class="jdgm-widget jdgm-preview-badge" data-id="' + escapeHtml(productId) + '" data-template="search" data-auto-install="false"></span>',
      '</span>'
    ].join('');
  }

  function sanitizeReviewBadgeMarkup(markup) {
    if (!markup) return '';

    var container = document.createElement('div');
    container.innerHTML = markup;

    Array.prototype.slice.call(container.querySelectorAll('[style]')).forEach(function (node) {
      node.removeAttribute('style');
    });

    var prevBadge = container.querySelector('.jdgm-prev-badge') || container.querySelector('[data-number-of-reviews]');
    var reviewCount = prevBadge ? prevBadge.getAttribute('data-number-of-reviews') : container.getAttribute('data-number-of-reviews');
    var badgeText = container.textContent || '';

    if (reviewCount === '0' || /no reviews/i.test(badgeText)) {
      return '';
    }

    return container.innerHTML.trim();
  }

  function chevronMarkup() {
    return [
      '<span class="ff-native-search__product-chevron" aria-hidden="true">',
      '<svg viewBox="0 0 24 24"><path d="M9 18 15 12 9 6"></path></svg>',
      '</span>'
    ].join('');
  }

  function productMarkup(product) {
    var image = normalizeImage(product.image);
    var price = formatPrice(product.price);
    var title = product.title || product.name || '';
    var mpn = product.mpn || product.sku || '';

    return [
      '<a class="search-bar__result-item ff-native-search__product" href="' + normalizeUrl(product.url) + '">',
      '<span class="search-bar__image-container ff-native-search__image">',
      image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span class="ff-native-search__image-placeholder"></span>',
      '</span>',
      '<span class="search-bar__item-info ff-native-search__item-info">',
      '<span class="search-bar__item-title ff-native-search__title">' + escapeHtml(title) + '</span>',
      ratingMarkup(product),
      mpn ? '<span class="ff-native-search__mpn"><span class="ff-native-search__mpn-label">MPN</span><span class="ff-native-search__mpn-code">' + escapeHtml(mpn) + '</span></span>' : '<span class="ff-native-search__mpn ff-native-search__mpn--empty" aria-hidden="true"></span>',
      '<span class="ff-native-search__price-row">',
      price ? '<span class="search-bar__item-price ff-native-search__price">' + escapeHtml(price) + '</span>' : '<span class="search-bar__item-price ff-native-search__price ff-native-search__price--empty" aria-hidden="true"></span>',
      chevronMarkup(),
      '</span>',
      '</span>',
      '</a>'
    ].join('');
  }

  function getProductHandle(product) {
    if (!product || !product.url) return '';

    try {
      var url = new URL(normalizeUrl(product.url), window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) {
      var fallbackMatch = String(product.url).match(/\/products\/([^/?#]+)/);
      return fallbackMatch ? fallbackMatch[1] : '';
    }
  }

  function normalizeLookupValue(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function chooseMatchingSku(details, query) {
    if (!details || !Array.isArray(details.variants)) return '';

    var normalizedQuery = normalizeLookupValue(query);
    var firstSku = '';

    for (var i = 0; i < details.variants.length; i += 1) {
      var sku = details.variants[i] && details.variants[i].sku ? String(details.variants[i].sku).trim() : '';
      if (!sku) continue;

      if (!firstSku) firstSku = sku;

      var normalizedSku = normalizeLookupValue(sku);
      if (normalizedSku && normalizedQuery && (normalizedSku.indexOf(normalizedQuery) !== -1 || normalizedQuery.indexOf(normalizedSku) !== -1)) {
        return sku;
      }
    }

    return firstSku;
  }

  function fetchProductDetails(handle) {
    if (!handle) return Promise.resolve(null);
    if (productDetailsCache.has(handle)) return productDetailsCache.get(handle);

    var request = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product details request failed');
        return response.json();
      })
      .catch(function () {
        return null;
      });

    productDetailsCache.set(handle, request);
    return request;
  }

  function getProductPageUrl(product) {
    if (!product || !product.url) return '';

    try {
      var url = new URL(normalizeUrl(product.url), window.location.origin);
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (error) {
      return normalizeUrl(String(product.url).split('?')[0]);
    }
  }

  function extractReviewBadgeMarkup(html, productId) {
    if (!html || !window.DOMParser) return '';

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var badges = Array.prototype.slice.call(doc.querySelectorAll('.jdgm-widget.jdgm-preview-badge'));
    var productIdString = productId ? String(productId).trim() : '';
    var badge = null;

    badges.some(function (candidate) {
      if (!productIdString || candidate.getAttribute('data-id') === productIdString) {
        badge = candidate;
        return true;
      }

      return false;
    });

    if (!badge && badges.length) {
      badge = badges[0];
    }

    if (!badge) return '';

    return sanitizeReviewBadgeMarkup(badge.innerHTML);
  }

  function fetchSearchReviewData(query) {
    var normalizedQuery = String(query || '').trim();

    if (!normalizedQuery) return Promise.resolve({});
    if (searchReviewDataCache.has(normalizedQuery)) return searchReviewDataCache.get(normalizedQuery);

    function mapBadge(map, id, handle, badgeMarkup) {
      var badge = sanitizeReviewBadgeMarkup(badgeMarkup || '');

      if (!badge) return;

      if (id) map['id:' + String(id)] = badge;
      if (handle) map['handle:' + String(handle)] = badge;
    }

    function parseJsonReviewData(text) {
      var map = {};
      var data = JSON.parse(text);
      var products = data && Array.isArray(data.products) ? data.products : [];

      products.forEach(function (item) {
        mapBadge(map, item.id, item.handle, item.badge);
      });

      return map;
    }

    function parseHtmlReviewData(text) {
      var map = {};

      if (!text || !window.DOMParser) return map;

      var doc = new DOMParser().parseFromString(text, 'text/html');
      var badges = Array.prototype.slice.call(doc.querySelectorAll('.jdgm-widget.jdgm-preview-badge'));

      badges.forEach(function (badge) {
        var id = badge.getAttribute('data-id') || '';
        var productItem = badge.closest('.product-item');
        var productLink = productItem ? productItem.querySelector('a[href*="/products/"]') : null;
        var handle = '';

        if (productLink) {
          var href = productLink.getAttribute('href') || '';
          var match = href.match(/\/products\/([^/?#]+)/);
          handle = match ? match[1] : '';
        }

        mapBadge(map, id, handle, badge.innerHTML);
      });

      return map;
    }

    var request = fetch('/search?view=ff-native-badges&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(normalizedQuery), {
      headers: {
        Accept: 'application/json, text/html'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search review data request failed');
        return response.text();
      })
      .then(function (text) {
        try {
          return parseJsonReviewData(text);
        } catch (error) {
          return parseHtmlReviewData(text);
        }
      })
      .catch(function () {
        return {};
      });

    searchReviewDataCache.set(normalizedQuery, request);
    return request;
  }

  function fetchProductReviewBadge(product) {
    var url = getProductPageUrl(product);
    var productId = product && product.id ? String(product.id).trim() : '';

    if (!url) return Promise.resolve('');
    if (productReviewBadgeCache.has(url)) return productReviewBadgeCache.get(url);

    var request = fetch(url, {
      headers: {
        Accept: 'text/html'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product review badge request failed');
        return response.text();
      })
      .then(function (html) {
        return extractReviewBadgeMarkup(html, productId);
      })
      .catch(function () {
        return '';
      });

    productReviewBadgeCache.set(url, request);
    return request;
  }

  function enrichProducts(products, query) {
    if (!products || !products.length) return Promise.resolve(products || []);

    return fetchSearchReviewData(query).then(function (reviewData) {
      return Promise.all(products.map(function (product) {
        var handle = getProductHandle(product);
        var directReviewBadgeHtml = reviewData['handle:' + handle] || (product.id ? reviewData['id:' + String(product.id)] : '');

        return Promise.all([
          fetchProductDetails(handle),
          directReviewBadgeHtml ? Promise.resolve('') : fetchProductReviewBadge(product)
        ]).then(function (values) {
          var details = values[0];
          var reviewBadgeHtml = directReviewBadgeHtml || values[1];

          if (reviewBadgeHtml) {
            product.reviewBadgeHtml = reviewBadgeHtml;
          }

          if (!details) return product;

          var sku = chooseMatchingSku(details, query);
          if (sku) {
            product.mpn = sku;
          }

          if (!product.vendor && details.vendor) {
            product.vendor = details.vendor;
          }

          if (!product.id && details.id) {
            product.id = details.id;
          }

          if (!product.reviewBadgeHtml && details.id) {
            product.reviewBadgeHtml = reviewData['id:' + String(details.id)] || '';
          }

          return product;
        });
      }));
    });
  }

  function refreshJudgeMeWidgets(root) {
    if (!root || !root.querySelector('.jdgm-widget')) return;

    window.setTimeout(function () {
      if (!window.jdgm) return;

      [
        'initializeWidgets',
        'renderWidgets',
        'refreshWidgets',
        'initializeBadges'
      ].some(function (method) {
        if (typeof window.jdgm[method] === 'function') {
          window.jdgm[method]();
          return true;
        }

        return false;
      });
    }, 80);
  }

  function searchUrl(query) {
    return '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
  }

  function enforceNativeSearchAction(form) {
    if (!form) return;

    form.setAttribute('action', '/search');
    form.setAttribute('method', 'get');
  }

  function navigateToSearch(form, query) {
    var normalizedQuery = String(query || '').trim();

    if (!normalizedQuery) return;

    enforceNativeSearchAction(form);
    closeDedicatedMobileSearch();
    document.documentElement.classList.remove('ff-mobile-search-open');
    if (document.body) {
      document.body.classList.remove('ff-mobile-search-open');
    }
    window.location.assign(searchUrl(normalizedQuery));
  }

  function iconMarkup(type) {
    if (type === 'search') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m16 16 4 4"></path></svg>';
    }

    return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 10v6"></path><path d="M12 7h.01"></path></svg>';
  }

  function compactTitle(value, maxLength) {
    var title = String(value || '').trim();
    if (!title || title.length <= maxLength) return title;
    return title.slice(0, maxLength - 1).trim() + '…';
  }

  function buildSuggestionItems(query, products) {
    var suggestions = [];
    var productText = (products || []).map(function (product) {
      return [product.title, product.type].join(' ');
    }).join(' ');

    function addSuggestion(value) {
      var suggestion = String(value || '').trim();
      var key = suggestion.toLowerCase();

      if (!suggestion || suggestions.some(function (item) { return item.toLowerCase() === key; })) return;
      suggestions.push(suggestion);
    }

    addSuggestion(query);

    if (/\bfilter/i.test(productText) && !/\bfilter\b/i.test(query)) {
      addSuggestion(query + ' filter');
    }

    if (/\bwater filter/i.test(productText) && !/\bwater filter\b/i.test(query)) {
      addSuggestion(query + ' water filter');
    }

    if (/\bfitting|\badapter|\bconnector/i.test(productText) && !/\bfitting|\badapter|\bconnector/i.test(query)) {
      addSuggestion(query + ' fitting');
    }

    (products || []).some(function (product) {
      var mpn = product.mpn || product.sku || '';
      if (mpn) {
        addSuggestion(query + ' ' + mpn);
      }

      return suggestions.length >= 4;
    });

    return suggestions.slice(0, 4);
  }

  function suggestionMarkup(suggestion) {
    return [
      '<a class="ff-native-search__side-link ff-native-search__side-link--suggestion" href="' + searchUrl(suggestion) + '">',
      iconMarkup('search'),
      '<span>' + escapeHtml(suggestion) + '</span>',
      '</a>'
    ].join('');
  }

  function sideLinkMarkup(item) {
    return [
      '<a class="ff-native-search__side-link" href="' + normalizeUrl(item.url) + '">',
      iconMarkup('info'),
      '<span>' + escapeHtml(compactTitle(item.title || item.name || '', 58)) + '</span>',
      '</a>'
    ].join('');
  }

  function sideSectionMarkup(title, items, renderer) {
    if (!items || !items.length) return '';

    return [
      '<div class="ff-native-search__side-section">',
      '<p class="ff-native-search__side-heading">' + escapeHtml(title) + '</p>',
      items.map(renderer).join(''),
      '</div>'
    ].join('');
  }

  function linkMarkup(item) {
    return '<a class="search-bar__result-link ff-native-search__link" href="' + normalizeUrl(item.url) + '">' + escapeHtml(item.title || item.name || '') + '</a>';
  }

  function renderResults(form, query, results) {
    var panel = ensurePanel(form);

    var products = results.products || [];
    var collections = results.collections || [];
    var articles = results.articles || [];
    var pages = results.pages || [];
    var suggestions = buildSuggestionItems(query, products);
    var markup = '';
    var isMobileSearch = form && form.hasAttribute('data-ff-mobile-search-form');

    if (products.length || suggestions.length || collections.length || articles.length || pages.length) {
      markup += '<div class="ff-native-search__layout">';

      if (!isMobileSearch) {
        markup += '<aside class="ff-native-search__side">';
        markup += sideSectionMarkup('Popular suggestions', suggestions, suggestionMarkup);
        markup += sideSectionMarkup('Categories', collections.slice(0, 3), sideLinkMarkup);
        markup += sideSectionMarkup('Blog posts', articles.slice(0, 3), sideLinkMarkup);
        markup += sideSectionMarkup('Pages', pages.slice(0, 2), sideLinkMarkup);
        markup += '</aside>';
      } else if (collections.length) {
        markup += '<aside class="ff-native-search__side ff-native-search__side--priority">';
        markup += sideSectionMarkup('Categories', collections.slice(0, 3), sideLinkMarkup);
        markup += '</aside>';
      }

      markup += '<section class="search-bar__result-products ff-native-search__products">';
      markup += '<p class="search-bar__result-category">Products</p>';
      if (products.length) {
        markup += '<div class="ff-native-search__product-grid">';
        markup += products.slice(0, 3).map(productMarkup).join('');
        markup += '</div>';
      } else {
        markup += '<div class="search-bar__empty-state ff-native-search__empty"><strong>No product matches found</strong><span>Search all products for “' + escapeHtml(query) + '”.</span></div>';
      }
      markup += viewAllMarkup(query);
      markup += '</section>';

      if (isMobileSearch) {
        markup += '<aside class="ff-native-search__side ff-native-search__side--secondary">';
        markup += sideSectionMarkup('Popular suggestions', suggestions, suggestionMarkup);
        markup += sideSectionMarkup('Blog posts', articles.slice(0, 3), sideLinkMarkup);
        markup += sideSectionMarkup('Pages', pages.slice(0, 2), sideLinkMarkup);
        markup += '</aside>';
      }

      markup += '</div>';
    }

    if (!markup) {
      markup = [
        '<div class="search-bar__empty-state ff-native-search__empty">',
        '<strong>No quick results found</strong>',
        '<span>Search all products for “' + escapeHtml(query) + '”.</span>',
        '</div>'
      ].join('');
    }

    panel.innerHTML = markup;
    refreshJudgeMeWidgets(panel);
    positionPanel(form, panel);
    setExpanded(form, true);
  }

  function closeSearch(form) {
    setExpanded(form, false);
    setLoading(form, false);
  }

  function getSearchWrapper(form) {
    return form ? form.closest('.header__search-bar-wrapper') : null;
  }

  function getSearchHeader(form) {
    return form ? form.closest('.header') : null;
  }

  function getSearchToggle(header) {
    return header ? header.querySelector('[data-action="toggle-search"]') : null;
  }

  function isDedicatedMobileSearchForm(form) {
    return !!(form && form.hasAttribute('data-ff-mobile-search-form'));
  }

  function isolateSearchInput(input) {
    if (!input || input.getAttribute('data-ff-native-search-isolated') === 'true') {
      return input;
    }

    var replacement = input.cloneNode(true);
    replacement.value = input.value;
    replacement.setAttribute('data-ff-native-search-isolated', 'true');
    replacement.setAttribute('data-searchanise-ignore', 'true');
    replacement.setAttribute('data-no-searchanise', 'true');
    replacement.setAttribute('data-snize-ignore', 'true');
    replacement.classList.remove('snize-input-style');
    input.replaceWith(replacement);

    return replacement;
  }

  function releaseThemeMobileSearch(form) {
    var wrapper = getSearchWrapper(form);
    var input = form ? form.querySelector(INPUT_SELECTOR) : null;

    if (wrapper) {
      wrapper.classList.remove('is-fixed');
    }

    if (input) {
      input.classList.remove('snize-input-style');
      input.setAttribute('data-searchanise-ignore', 'true');
      input.setAttribute('data-no-searchanise', 'true');
      input.setAttribute('data-snize-ignore', 'true');
    }

    document.documentElement.classList.remove('snize-instant-widget-is-open', 'snize-ac-overhidden', 'snize-overhidden');

    if (document.body) {
      var hadSearchaniseState = document.body.classList.contains('snize-instant-widget-is-open') ||
        document.body.classList.contains('snize-ac-overhidden') ||
        document.body.classList.contains('snize-overhidden');

      document.body.classList.remove('no-mobile-scroll', 'snize-instant-widget-is-open', 'snize-ac-overhidden', 'snize-overhidden');

      if (hadSearchaniseState) {
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('height');
      }
    }
  }

  function openMobileSearch(form, shouldFocus) {
    var wrapper = getSearchWrapper(form);
    var header = getSearchHeader(form);
    var toggle = getSearchToggle(header);
    var input = form ? form.querySelector(INPUT_SELECTOR) : null;

    if (!form || !wrapper || !header || !input) return;

    releaseThemeMobileSearch(form);
    document.documentElement.classList.add('ff-mobile-search-open');
    if (document.body) {
      document.body.classList.add('ff-mobile-search-open');
    }
    header.classList.add('header--search-expanded');
    wrapper.classList.add('is-visible');
    wrapper.classList.remove('is-fixed');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }

    if (input.value.trim().length >= MIN_QUERY_LENGTH) {
      search(form, input.value);
    }

    if (shouldFocus) {
      input.focus({ preventScroll: true });
      stabilizeMobileSearch(form, input, true);
    }
  }

  function closeMobileSearch(form) {
    var wrapper = getSearchWrapper(form);
    var header = getSearchHeader(form);
    var toggle = getSearchToggle(header);

    if (!form) return;

    closeSearch(form);
    releaseThemeMobileSearch(form);
    document.documentElement.classList.remove('ff-mobile-search-open');
    if (document.body) {
      document.body.classList.remove('ff-mobile-search-open');
    }

    if (wrapper) {
      wrapper.classList.remove('is-visible', 'is-fixed');
    }

    if (header) {
      header.classList.remove('header--search-expanded');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function ensureDedicatedMobileSearch(sourceForm) {
    if (mobileSearchOverlay && document.documentElement.contains(mobileSearchOverlay)) {
      return mobileSearchOverlay;
    }

    var overlay = document.createElement('div');
    overlay.id = MOBILE_OVERLAY_ID;
    overlay.className = 'ff-mobile-search-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    var form = document.createElement('form');
    form.className = 'ff-mobile-search-form';
    form.setAttribute('action', '/search');
    form.setAttribute('method', 'get');
    form.setAttribute('role', 'search');
    form.setAttribute('data-ff-native-search', '');
    form.setAttribute('data-ff-mobile-search-form', '');

    [
      ['type', 'product'],
      ['options[prefix]', 'last']
    ].forEach(function (item) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = item[0];
      hidden.value = item[1];
      form.appendChild(hidden);
    });

    var sourceUnavailableInput = sourceForm ? sourceForm.querySelector('input[name="options[unavailable_products]"]') : null;
    if (sourceUnavailableInput) {
      var unavailable = document.createElement('input');
      unavailable.type = 'hidden';
      unavailable.name = 'options[unavailable_products]';
      unavailable.value = sourceUnavailableInput.value;
      form.appendChild(unavailable);
    }

    var bar = document.createElement('div');
    bar.className = 'ff-mobile-search-overlay__bar';

    var input = document.createElement('input');
    input.className = 'ff-mobile-search-overlay__input';
    input.type = 'search';
    input.name = 'q';
    input.autocomplete = 'off';
    input.autocorrect = 'off';
    input.placeholder = sourceForm ? (sourceForm.querySelector(INPUT_SELECTOR) || {}).placeholder || 'Search by model number, brand or type...' : 'Search by model number, brand or type...';
    input.setAttribute('aria-label', 'Search by model number, brand or type');
    input.setAttribute('data-ff-native-search-input', '');
    input.setAttribute('data-searchanise-ignore', 'true');
    input.setAttribute('data-no-searchanise', 'true');
    input.setAttribute('data-snize-ignore', 'true');

    var submit = document.createElement('button');
    submit.className = 'ff-mobile-search-overlay__submit';
    submit.type = 'submit';
    submit.setAttribute('aria-label', 'Search');
    submit.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m16 16 4 4"></path></svg>';

    var close = document.createElement('button');
    close.className = 'ff-mobile-search-overlay__close';
    close.type = 'button';
    close.setAttribute('data-ff-mobile-search-close', '');
    close.setAttribute('aria-label', 'Close search');
    close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';

    bar.appendChild(input);
    bar.appendChild(submit);
    bar.appendChild(close);
    form.appendChild(bar);
    overlay.appendChild(form);
    document.body.appendChild(overlay);

    initSearchForm(form);
    mobileSearchOverlay = overlay;

    return overlay;
  }

  function getDedicatedMobileSearchForm() {
    return mobileSearchOverlay ? mobileSearchOverlay.querySelector(SEARCH_SELECTOR) : null;
  }

  function openDedicatedMobileSearch(sourceForm) {
    var overlay = ensureDedicatedMobileSearch(sourceForm);
    var form = overlay.querySelector(SEARCH_SELECTOR);
    var input = form ? form.querySelector(INPUT_SELECTOR) : null;
    var sourceInput = sourceForm ? sourceForm.querySelector(INPUT_SELECTOR) : null;
    var toggle = document.querySelector('[data-action="toggle-search"]');

    if (!form || !input) return;

    if (document.body && overlay.parentNode === document.body) {
      document.body.appendChild(overlay);
    }

    if (sourceInput && sourceInput.value && !input.value) {
      input.value = sourceInput.value;
    }

    removeThirdPartyAutocomplete();
    document.documentElement.classList.add('ff-mobile-search-open');
    if (document.body) {
      document.body.classList.add('ff-mobile-search-open');
    }

    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }

    if (input.value.trim().length >= MIN_QUERY_LENGTH) {
      search(form, input.value);
    }

    input.focus({ preventScroll: true });
    stabilizeMobileSearch(form, input, true);
  }

  function closeDedicatedMobileSearch() {
    var form = getDedicatedMobileSearchForm();
    var toggle = document.querySelector('[data-action="toggle-search"]');

    if (form) {
      closeSearch(form);
    }

    if (mobileSearchOverlay) {
      mobileSearchOverlay.classList.remove('is-visible');
      mobileSearchOverlay.setAttribute('aria-hidden', 'true');
    }

    document.documentElement.classList.remove('ff-mobile-search-open');
    if (document.body) {
      document.body.classList.remove('ff-mobile-search-open');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function restoreMobileSearchShell(form) {
    if (form && form.hasAttribute('data-ff-mobile-search-form')) {
      if (mobileSearchOverlay) {
        document.documentElement.classList.add('ff-mobile-search-open');
        if (document.body) {
          document.body.classList.add('ff-mobile-search-open');
        }
        mobileSearchOverlay.classList.add('is-visible');
        mobileSearchOverlay.setAttribute('aria-hidden', 'false');
      }
      return;
    }

    var wrapper = getSearchWrapper(form);
    var header = getSearchHeader(form);
    var toggle = getSearchToggle(header);

    if (!form || !wrapper || !header) return;

    releaseThemeMobileSearch(form);
    document.documentElement.classList.add('ff-mobile-search-open');
    if (document.body) {
      document.body.classList.add('ff-mobile-search-open');
    }
    header.classList.add('header--search-expanded');
    wrapper.classList.add('is-visible');
    wrapper.classList.remove('is-fixed');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  function stabilizeMobileSearch(form, input, shouldFocus) {
    var delays = [0, 60, 180, 360];

    delays.forEach(function (delay) {
      window.setTimeout(function () {
        if (!form || !document.documentElement.contains(form)) return;

        removeThirdPartyAutocomplete();
        restoreMobileSearchShell(form);

        if (shouldFocus && input && document.documentElement.contains(input) && document.activeElement !== input) {
          input.focus({ preventScroll: true });
        }

        if (form.classList.contains('ff-native-search--open')) {
          positionPanel(form, form.querySelector('.' + PANEL_CLASS));
        }
      }, delay);
    });
  }

  function removeThirdPartyAutocomplete() {
    document.documentElement.classList.remove('snize-instant-widget-is-open', 'snize-ac-overhidden', 'snize-overhidden');

    if (document.body) {
      document.body.classList.remove('snize-instant-widget-is-open', 'snize-ac-overhidden', 'snize-overhidden');
    }

    document.querySelectorAll(THIRD_PARTY_AUTOCOMPLETE_SELECTORS).forEach(function (node) {
      node.setAttribute('aria-hidden', 'true');
      node.style.display = 'none';
      node.style.visibility = 'hidden';
      node.style.pointerEvents = 'none';
    });
  }

  function startThirdPartyObserver() {
    if (thirdPartyObserver || !window.MutationObserver) return;

    thirdPartyObserver = new MutationObserver(function () {
      removeThirdPartyAutocomplete();
    });

    thirdPartyObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function ensurePanel(form) {
    var panel = form.querySelector('.' + PANEL_CLASS);
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = PANEL_CLASS;
    panel.setAttribute('aria-hidden', 'true');

    var topWrapper = form.querySelector('.search-bar__top-wrapper');
    if (topWrapper && topWrapper.nextSibling) {
      form.insertBefore(panel, topWrapper.nextSibling);
    } else {
      form.appendChild(panel);
    }

    return panel;
  }

  function search(form, query) {
    var normalizedQuery = query.trim();

    removeThirdPartyAutocomplete();

    if (normalizedQuery.length < MIN_QUERY_LENGTH) {
      closeSearch(form);
      return;
    }

    if (cache.has(normalizedQuery)) {
      renderResults(form, normalizedQuery, cache.get(normalizedQuery));
      return;
    }

    if (activeController) {
      activeController.abort();
    }

    activeController = new AbortController();
    setLoading(form, true);
    setExpanded(form, true);

    fetch(buildSuggestUrl(normalizedQuery), {
      signal: activeController.signal,
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.json();
      })
      .then(function (data) {
        var results = data && data.resources && data.resources.results ? data.resources.results : {};
        return enrichProducts(results.products || [], normalizedQuery).then(function (products) {
          results.products = products;
          cache.set(normalizedQuery, results);
          renderResults(form, normalizedQuery, results);
        });
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        renderResults(form, normalizedQuery, {});
      })
      .finally(function () {
        setLoading(form, false);
      });
  }

  function getSearchParts(target) {
    var input = target && target.closest ? target.closest(INPUT_SELECTOR) : null;
    if (!input) return null;

    var form = input.closest(SEARCH_SELECTOR);
    if (!form) return null;

    initSearchForm(form);

    return {
      form: form,
      input: input
    };
  }

  function scheduleSearch(form, input) {
    var existingTimer = formTimers.get(form);
    if (existingTimer) {
      clearTimeout(existingTimer);
    }

    var timer = setTimeout(function () {
      search(form, input.value);
    }, 120);

    formTimers.set(form, timer);
  }

  function ownNativeSearchEvent(event) {
    var parts = getSearchParts(event.target);
    if (!parts) return null;

    enforceNativeSearchAction(parts.form);
    removeThirdPartyAutocomplete();
    releaseThemeMobileSearch(parts.form);
    event.stopImmediatePropagation();

    return parts;
  }

  function getNativeSearchInputFromEvent(event) {
    if (!event.target.closest) return null;

    var input = event.target.closest(INPUT_SELECTOR);
    if (!input) return null;

    var form = input.closest(SEARCH_SELECTOR);
    if (!form) return null;

    initSearchForm(form);

    return {
      form: form,
      input: input
    };
  }

  function onNativeSearchInputPointer(event) {
    var parts = getNativeSearchInputFromEvent(event);
    if (!parts) return;

    removeThirdPartyAutocomplete();
    event.stopImmediatePropagation();

    if (isCompactViewport()) {
      if (!isDedicatedMobileSearchForm(parts.form)) {
        event.preventDefault();
        openDedicatedMobileSearch(parts.form);
        return;
      }
    } else {
      releaseThemeMobileSearch(parts.form);
    }

    if (event.type === 'pointerdown' || event.type === 'mousedown' || event.type === 'touchstart' || event.type === 'click') {
      parts.input.focus({ preventScroll: true });

      window.setTimeout(function () {
        removeThirdPartyAutocomplete();
        if (!isCompactViewport()) {
          releaseThemeMobileSearch(parts.form);
        }
        parts.input.focus({ preventScroll: true });
      }, 0);
    }
  }

  function onNativeSearchInput(event) {
    var parts = ownNativeSearchEvent(event);
    if (!parts) return;

    scheduleSearch(parts.form, parts.input);
  }

  function onNativeSearchKeyup(event) {
    var parts = ownNativeSearchEvent(event);
    if (!parts) return;

    if (event.key !== 'Escape') {
      scheduleSearch(parts.form, parts.input);
    }
  }

  function onNativeSearchKeydown(event) {
    var parts = getSearchParts(event.target);
    if (!parts) return;

    enforceNativeSearchAction(parts.form);
    removeThirdPartyAutocomplete();

    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      closeSearch(parts.form);
      parts.input.blur();
      return;
    }

    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      event.stopImmediatePropagation();
      navigateToSearch(parts.form, parts.input.value);
      return;
    }

    if (event.key !== 'Enter') {
      event.stopImmediatePropagation();
    }
  }

  function onNativeSearchSubmit(event) {
    if (!event.target || !event.target.closest) return;

    var form = event.target.closest(SEARCH_SELECTOR);
    if (!form) return;

    initSearchForm(form);

    var input = form.querySelector(INPUT_SELECTOR);
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    navigateToSearch(form, input.value);
  }

  function onNativeSearchFocus(event) {
    var parts = getSearchParts(event.target);
    if (!parts) return;

    removeThirdPartyAutocomplete();
    event.stopImmediatePropagation();

    if (isCompactViewport()) {
      if (!isDedicatedMobileSearchForm(parts.form)) {
        openDedicatedMobileSearch(parts.form);
        return;
      }
    } else {
      releaseThemeMobileSearch(parts.form);

      window.setTimeout(function () {
        releaseThemeMobileSearch(parts.form);
      }, 0);
    }

    if (parts.input.value.trim().length >= MIN_QUERY_LENGTH) {
      search(parts.form, parts.input.value);
    }
  }

  function onNativeSearchControlClick(event) {
    if (!event.target.closest) return;

    var mobileClose = event.target.closest('[data-ff-mobile-search-close]');
    if (mobileClose) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDedicatedMobileSearch();
      return;
    }

    var toggle = event.target.closest('[data-action="toggle-search"]');

    if (toggle) {
      var header = toggle.closest('.header') || document.querySelector('.header');
      var form = header ? header.querySelector(SEARCH_SELECTOR) : document.querySelector(SEARCH_SELECTOR);
      var wrapper = getSearchWrapper(form);
      var input = form ? form.querySelector(INPUT_SELECTOR) : null;
      var isOpen = wrapper && wrapper.classList.contains('is-visible');

      if (!form || !input) return;

      event.stopImmediatePropagation();
      removeThirdPartyAutocomplete();

      if (isCompactViewport()) {
        event.preventDefault();
        openDedicatedMobileSearch(form);
        return;
      }

      if (event.type !== 'click') {
        releaseThemeMobileSearch(form);
        return;
      }

      event.preventDefault();

      if (isOpen) {
        closeMobileSearch(form);
      } else {
        openMobileSearch(form, true);
      }

      window.setTimeout(function () {
        removeThirdPartyAutocomplete();
        releaseThemeMobileSearch(form);
      }, 0);

      return;
    }

    var closeButton = event.target.closest('[data-action="unfix-search"]');

    if (closeButton) {
      var closeForm = closeButton.closest(SEARCH_SELECTOR);

      if (closeForm) {
        event.stopImmediatePropagation();
        if (event.type !== 'click') return;
        event.preventDefault();
        closeMobileSearch(closeForm);
      }
    }
  }

  function onNativeSearchClick(event) {
    if (!event.target.closest) return;

    if (event.target.closest('[data-ff-mobile-search-close]')) {
      closeDedicatedMobileSearch();
      return;
    }

    if (event.target.closest('[data-action="toggle-search"]')) {
      return;
    }

    var closeButton = event.target.closest('[data-action="unfix-search"]');
    if (closeButton) {
      var closeForm = closeButton.closest(SEARCH_SELECTOR);
      if (closeForm) closeMobileSearch(closeForm);
      return;
    }

    var clearButton = event.target.closest('[data-action="clear-input"]');
    if (clearButton) {
      var form = clearButton.closest(SEARCH_SELECTOR);
      var input = form ? form.querySelector(INPUT_SELECTOR) : null;

      if (form && input) {
        input.value = '';
        closeSearch(form);
        removeThirdPartyAutocomplete();
      }
    }

    document.querySelectorAll(SEARCH_SELECTOR).forEach(function (form) {
      if (!form.contains(event.target)) {
        closeSearch(form);
      }
    });
  }

  function initSearchForm(form) {
    if (!form || initializedForms.has(form)) return;

    var input = isolateSearchInput(form.querySelector(INPUT_SELECTOR));
    if (!input) return;

    initializedForms.add(form);
    enforceNativeSearchAction(form);
    document.documentElement.classList.add('ff-native-search-enabled');

    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('data-searchanise-ignore', 'true');
    input.setAttribute('data-no-searchanise', 'true');
    ensurePanel(form);

    form.addEventListener('submit', function (event) {
      if (input.value.trim().length === 0) {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      navigateToSearch(form, input.value);
    }, true);
  }

  function initAll() {
    document.querySelectorAll(SEARCH_SELECTOR).forEach(initSearchForm);
    bindGlobalEvents();
    removeThirdPartyAutocomplete();
    startThirdPartyObserver();
  }

  function bindGlobalEvents() {
    if (globalsBound) return;
    globalsBound = true;

    window.addEventListener('input', onNativeSearchInput, true);
    window.addEventListener('submit', onNativeSearchSubmit, true);
    window.addEventListener('keyup', onNativeSearchKeyup, true);
    window.addEventListener('keydown', onNativeSearchKeydown, true);
    window.addEventListener('focusin', onNativeSearchFocus, true);
    window.addEventListener('click', onNativeSearchControlClick, true);
    window.addEventListener('pointerdown', onNativeSearchInputPointer, true);
    window.addEventListener('mousedown', onNativeSearchInputPointer, true);
    window.addEventListener('touchstart', onNativeSearchInputPointer, true);
    window.addEventListener('click', onNativeSearchInputPointer, true);
    document.addEventListener('input', onNativeSearchInput, true);
    document.addEventListener('submit', onNativeSearchSubmit, true);
    document.addEventListener('keyup', onNativeSearchKeyup, true);
    document.addEventListener('keydown', onNativeSearchKeydown, true);
    document.addEventListener('focusin', onNativeSearchFocus, true);
    document.addEventListener('click', onNativeSearchControlClick, true);
    document.addEventListener('pointerdown', onNativeSearchInputPointer, true);
    document.addEventListener('mousedown', onNativeSearchInputPointer, true);
    document.addEventListener('touchstart', onNativeSearchInputPointer, true);
    document.addEventListener('click', onNativeSearchInputPointer, true);
    document.addEventListener('click', onNativeSearchClick);
    window.addEventListener('resize', function () {
      document.querySelectorAll(SEARCH_SELECTOR + '.ff-native-search--open').forEach(function (form) {
        positionPanel(form, form.querySelector('.' + PANEL_CLASS));
      });
    });
    window.addEventListener('scroll', function () {
      document.querySelectorAll(SEARCH_SELECTOR + '.ff-native-search--open').forEach(function (form) {
        positionPanel(form, form.querySelector('.' + PANEL_CLASS));
      });
    }, true);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState !== 'loading') {
    initAll();
  }
})();
